var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"footer"},[_c('div',{staticClass:"container-fluid d-flex flex-wrap justify-content-between"},[_c('nav'),_c('div',{staticClass:"copyright d-flex flex-wrap"},[_vm._v("\n      © Canon 2022\n    ")])])])
}]

export { render, staticRenderFns }